<template>
    <div class="button-container" @click="onButtonClick">
        <div class="button next-btn" :class="{ 'mr-2': margin && margin === 'right', 'ml-2': margin && margin === 'left', }" v-if="type == 'next'">
            <span>{{ text }}&nbsp;></span>
        </div>
        <div class="button download-btn" :class="{ 'mr-2': margin && margin === 'right', 'ml-2': margin && margin === 'left', }" v-if="type == 'download'">
            <span>{{ text }}</span>
        </div>
        <div class="button prev-btn" :class="{ 'mr-2': margin && margin === 'right', 'ml-2': margin && margin === 'left', }" v-if="type == 'prev'">
            <svg width="7" height="8" viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.95213 7.872L0.384125 4.256L3.95213 0.655999H6.54413L2.94413 4.256L6.54413 7.872H3.95213Z" fill="#0892D0"/>
            </svg> <span>{{ text }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "OnboardingButton",
    props: [ 'type', 'text', 'margin'],
    data() {
        return {        
        }
    },
    methods: {
        onButtonClick() {
            this.$emit("onButtonClick");  
        }
    },
    mounted() {}
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/_reduced_variables.scss";

h1, h2, h3, h4, p {
    margin: 0;
    padding: 0;
    font-family: 'DM Sans', sans-serif;
    font-weight: 400;
}

.button {
    border: 1px solid #0892d0;
    border-radius: 5px;
    padding: 14px 36px;
    text-align: center;
    max-width: 154px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 5px;
    
    span {
        font-weight: 500;
        color: #0892d0;
    }
}


.next-btn {
    background: #0892d0;

    span {
        color: #FFFFFF;
    }
}

.download-btn {
    background: #FE7A11;
    border: 1px solid #FE7A11;

    span {
        color: #FFFFFF;
    }
}

.mr-2 {
    margin-right: 35px !important;
}

.ml-2 {
    margin-left: 35px !important;
}

</style>


// WEBPACK FOOTER //
// src/components/OnboardingButton.vue